module.exports = __webpack_public_path__ + "static/media/palomitas.daede4ea.png";